import React, { useState, useRef } from "react";
import Image from "next/image";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import Slider from "react-slick";

export interface StepProps {
  step: string;
  title: string;
  description: string;
  icon: string;
}

export interface ServiceProcessProps {
  steps: StepProps[];
  title: string;
  subTitle: string;
}

const ServiceProcess: React.FC<ServiceProcessProps> = ({
  steps,
  title,
  subTitle,
}) => {
  const sliderRef = useRef<any>(null);
  const [currentSlide, setCurrentSlide] = useState(0);
  const sliderSettings = {
    dots: true,
    beforeChange: (current: number, next: number) => {
      setCurrentSlide(next);
    },
    infinite: true,
    autoplay: true,
    autoplaySpeed: 5000,
    speed: 2000,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: true,

    customPaging: (i: number) => (
      <div
        style={{
          width: i === currentSlide ? "41px" : "12px",
          height: "12px",
          borderRadius: i === currentSlide ? "20px" : "50%",
          backgroundColor: i === currentSlide ? "#3586FF" : "#ccc",
          transition: "all 0.3s ease-in-out",
          margin: "-10px 4px",
          display: "inline-block",
        }}
      />
    ),

    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 425,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "5px",
        },
      },
      {
        breakpoint: 375,
        settings: {
          slidesToShow: 1,
          centerMode: true,
          centerPadding: "5px",
        },
      },
    ],
  };
  return (
    <div className="md:py-10 py-6 md:px-6 px-4">
      <div className="flex flex-col gap-2 items-center justify-center mb-8">
        <h1 className="font-Gordita-Medium md:text-[25px] text-[20px] text-center">
          {title}
        </h1>
        <h2 className="font-Gordita-Medium md:text-[20px] text-[18px] text-[#7B7C83] text-center">
          {subTitle}
        </h2>
      </div>
      <div className="hidden md:grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 relative  mt-16">
        {steps.map((step, index) => (
          <div
            key={index}
            className="relative border-dashed border-[2px] border-[#E5E5E5] p-6 rounded-md flex flex-col items-center"
          >
            <Image
              src={step.icon}
              alt={step.title}
              className="h-20 mb-4 rounded-[50%]"
              objectFit="cover"
              width={100}
              height={140}
            />
            <span className="bg-[#0052CC] absolute -top-[14px] right-4 transform -translate-x-[20%] text-white px-4 py-[6px] rounded-[4px] mb-4 text-sm font-Gordita-Medium">
              {step.step}
            </span>
            <h3 className="font-Gordita-Bold text-[20px] text-center mb-2">
              {step.title}
            </h3>
            <p className="font-Gordita-Regular text-center text-[#7B7C83]">
              {step.description}
            </p>
          </div>
        ))}
      </div>
      <div className="block md:hidden max-w-[390px] ">
        <Slider ref={sliderRef} {...sliderSettings}>
          {steps.map((step, index) => (
            <div
              key={index}
              className="relative border-dashed border-[2px] border-[#E5E5E5] p-3 rounded-md flex flex-col items-center m-1"
            >
              <Image
                src={step.icon}
                alt={step.title}
                className="h-20 mb-4 rounded-[50%]"
                objectFit="cover"
                width={100}
                height={140}
              />
              <span className="bg-[#0052CC] absolute -top-[11px] right-4 transform -translate-x-[20%] text-white px-4 py-[6px] rounded-[4px] mb-12 text-sm font-Gordita-Medium">
                {step.step}
              </span>
              <h3 className="font-Gordita-Bold md:text-[20px] text-[16px] text-center mb-2">
                {step.title}
              </h3>
              <p className="font-Gordita-Regular text-center md:text-[16px] text-[12px] text-[#7B7C83]">
                {step.description}
              </p>
            </div>
          ))}
        </Slider>
      </div>
    </div>
  );
};

export default ServiceProcess;
